import { useState } from 'react';
import type { PhotoMeta } from '../api.js';
import { api } from '../api.js';
import { t } from '../i18n.js';

export function PhotoLightbox({
  photo,
  onClose,
  onDeleted,
}: {
  photo: PhotoMeta;
  onClose: () => void;
  onDeleted: () => void;
}) {
  const [busy, setBusy] = useState(false);

  const handleDelete = async () => {
    if (!window.confirm(t('memories.delete_confirm'))) return;
    setBusy(true);
    try {
      await api.deletePhoto(photo.id);
      onDeleted();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox" onClick={(e) => e.stopPropagation()}>
        <img className="lightbox-img" src={photo.full_url} alt="" />
        <div className="lightbox-actions">
          <button className="lightbox-btn is-danger" onClick={handleDelete} disabled={busy}>
            {t('memories.delete')}
          </button>
          <button className="lightbox-btn" onClick={onClose} disabled={busy}>
            {t('memories.close')}
          </button>
        </div>
      </div>
    </div>
  );
}
